import { useRef, useState } from "react";
import { MoveHorizontal } from "lucide-react";

// Interactive drag-to-reveal before/after comparison. Both images are full-size
// and overlaid; the "before" layer is clipped from the right by the handle position.
export function BeforeAfterSlider({ beforeUrl, afterUrl, className = "" }) {
  const ref = useRef(null);
  const dragging = useRef(false);
  const [pos, setPos] = useState(50);

  const move = (clientX) => {
    const el = ref.current;
    if (!el) return;
    const r = el.getBoundingClientRect();
    setPos(Math.max(0, Math.min(100, ((clientX - r.left) / r.width) * 100)));
  };

  return (
    <div
      ref={ref}
      data-testid="before-after-slider"
      className={`relative aspect-[4/3] w-full select-none overflow-hidden rounded-xl bg-slate-100 ${className}`}
      style={{ touchAction: "none", cursor: "ew-resize" }}
      onPointerDown={(e) => { dragging.current = true; e.currentTarget.setPointerCapture?.(e.pointerId); move(e.clientX); }}
      onPointerMove={(e) => { if (dragging.current) move(e.clientX); }}
      onPointerUp={() => { dragging.current = false; }}
      onPointerCancel={() => { dragging.current = false; }}
    >
      <img src={afterUrl} alt="After" draggable={false} className="absolute inset-0 h-full w-full object-cover" />
      <img src={beforeUrl} alt="Before" draggable={false} className="absolute inset-0 h-full w-full object-cover"
        style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }} />

      <span className="pointer-events-none absolute bottom-2 left-2 rounded-full bg-black/55 px-2 py-0.5 text-[11px] font-bold uppercase tracking-wide text-white">Before</span>
      <span className="pointer-events-none absolute bottom-2 right-2 rounded-full bg-black/55 px-2 py-0.5 text-[11px] font-bold uppercase tracking-wide text-white">After</span>

      <div className="pointer-events-none absolute inset-y-0" style={{ left: `${pos}%`, transform: "translateX(-50%)" }}>
        <div className="h-full w-0.5 bg-white shadow-[0_0_6px_rgba(0,0,0,0.4)]" />
        <div className="absolute left-1/2 top-1/2 grid h-10 w-10 -translate-x-1/2 -translate-y-1/2 place-items-center rounded-full bg-white text-primary shadow-lg">
          <MoveHorizontal className="h-5 w-5" />
        </div>
      </div>
    </div>
  );
}
